import React from 'react';

import { IconViewfinder } from '@tabler/icons-react';
import clsx from 'clsx';
import { ModalNotStyled } from 'ui-kit';

import RequestAccess from './RequestAccess';

import { ListingType } from './MarketplaceTable';
type DealLinkProps = {
  isMyListing: boolean;
  listingHref: string;
  listingId: string;
  listingDetails: ListingType;
  dealId: string | null;
};

const DealLink: React.FC<DealLinkProps> = ({
  isMyListing,
  listingHref: _listingHref,
  listingId,
  listingDetails,
  dealId,
}) => {
  const handleTriggerClick = (e: React.MouseEvent) => {
    // Always prevent default behavior to show modal
    e.stopPropagation();
    e.preventDefault();
  };

  const Trigger = (
    <div
      onClick={(e) => {
        handleTriggerClick(e);
      }}
      className={clsx(
        'cursor-pointer rounded border-l-2 border-l-slate-700 bg-slate-700 py-2 pl-[6px] pr-2',
        {
          '!border-l-blue-500': isMyListing,
        },
      )}
    >
      <IconViewfinder size={20} className="text-slate-200" />
    </div>
  );

  return (
    <ModalNotStyled trigger={Trigger}>
      {({ closeModal }) => (
        <div className="flex max-h-[90vh] w-full max-w-[985px] flex-col overflow-hidden rounded-lg border border-pink-500 bg-background-canvas p-6 font-heebo text-white shadow-lg">
          <div className="flex shrink-0 items-center justify-between">
            <h2 className="min-w-0 truncate text-2xl font-semibold">{listingDetails.name}</h2>
            <button className="text-gray-500 hover:text-gray-300" onClick={closeModal}>
              ✕
            </button>
          </div>
          <RequestAccess
            listingId={listingId}
            listingDetails={listingDetails}
            dealId={dealId}
            isMyListing={isMyListing}
          />
        </div>
      )}
    </ModalNotStyled>
  );
};

export default DealLink;
